import { fetchSbStory } from "~/lib/storyblok/utils/fetch-sb-story"
import { handleZodSafeParse } from "~/lib/zod/utils/handle-zod-safe-parse"
import { dictionarySchema } from "~/providers/I18nProvider/constants"

export async function fetchDictionary(locale: string) {
  const dictionaryStory = await fetchSbStory(
    "globals/dictionary",
    {
      locale,
    },
    {}
  )

  return handleZodSafeParse(dictionarySchema, dictionaryStory.data.story.content, "fetchDictionary")
}
